import React from "react";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";

function WhoWeAre() {
    return (
        <div className="landing-page-component">
            <FrontHeader />
            <div className="page-content pb-5">
                <div className="container-easy-market">
                    <div className="container">
                        {/* Titre principal */}
                        <h1 className="yeksina-about-main-title">
                            Qui sommes-nous ? About Us
                        </h1>

                        {/* Première section : Image + Texte */}
                        <div className="yeksina-about-section">
                            <div className="row align-items-center">
                                {/* Image à gauche */}
                                <div className="col-md-6 col-lg-5">
                                    <div className="yeksina-about-image-container">
                                        <img 
                                            src="/Yesksina Contact.jpeg" 
                                            alt="YEKSINA HOME - Qui sommes-nous"
                                            className="yeksina-about-image"
                                        />
                                    </div>
                                </div>

                                {/* Texte à droite */}
                                <div className="col-md-6 col-lg-7">
                                    <div className="yeksina-about-content">
                                        <p className="yeksina-about-subtitle">
                                            QUI SOMMES-NOUS? / ABOUT US
                                        </p>
                                        <h2 className="yeksina-about-brand-name">
                                            YEKSINA HOME
                                        </h2>
                                        <div className="yeksina-about-description">
                                            <p>
                                                Créée au Sénégal en 2020, notre jeune entreprise est spécialisée dans l'art de vivre aux inspirations et influences africaines. Nous avons réussi à nous démarquer, notamment, grâce à la création de carreaux aux motifs africains. Cette touche unique est la première dans toute l'histoire du carrelage contemporain.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section texte pleine largeur */}
                        <div className="yeksina-about-full-text">
                            <div className="yeksina-about-text-french">
                                <p>
                                    Nous espérons que vous trouverez votre bonheur parmi les nouveaux modèles de carreaux décoratifs pour sols et/ou murs.
                                </p>
                                <p>
                                    YEKSINA signifie "Je suis là" ou "Je suis arrivée" en Wolof, première langue nationale parlée au Sénégal. Autrement dit, la décoration africaine entre enfin dans nos intérieurs.
                                </p>
                                <p>
                                    (Re)découvrez sur un support inédit comme le carrelage, la technique de représentation du Baobab du Sénégal, l'art décoratif traditionnel Imigongo du Rwanda, les déclinaisons de couleurs du masque soleil du Burkina Faso et du bouclier des fiers guerriers d'Afrique du Sud, ainsi que les motifs géométriques sublimés du Mali, etc.
                                </p>
                            </div>

                            <div className="yeksina-about-text-english">
                                <p>
                                    Founded in Senegal in 2020, our young company specializes in the art of living with African inspirations and influences.
                                </p>
                                <p>
                                    We have succeeded in standing out, in particular, thanks to the creation of tiles with African designs. This unique touch is the first in the entire history of contemporary tiling.
                                </p>
                                <p>
                                    We hope you will find what you are looking for among our new models of decorative tiles for floors and/or walls.
                                </p>
                                <p>
                                    YEKSINA means "I am here" or "I have arrived" in Wolof, the first national language spoken in Senegal. In other words, African decoration is finally entering our homes.
                                </p>
                                <p>
                                    (Re)discover, on a new medium like tiles, the technique of representing the Baobab tree from Senegal, the traditional decorative art of Imigongo from Rwanda, the color variations of the sun mask from Burkina Faso and the shield of the proud warriors of South Africa, as well as the sublime geometric patterns of Mali, among others.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FrontFooter />
        </div>
    );
}

export default WhoWeAre;